package org.lennycodes.gradematewebsite.util

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.lennycodes.gradematewebsite.components.style.GradeMateColors


data class DownloadOption(
    val platform: String,
    val version: String,
    val size: String,
    val accent: Color,
    val href: String,
    val description: String
)
enum class Platform(
    val label: String,
    val minOs: String,
    val storage: String,
    val extra: String
) {
    Android(
        "Android",
        "Android 8.0 (Oreo) or later",
        "80 MB free storage",
        "Internet connection for sync"
    ),

    Windows(
        "Windows",
        "Windows 10 or later (64-bit)",
        "150 MB free storage",
        "4 GB RAM recommended, Internet connection"
    ),

    Linux(
        "Linux",
        "Ubuntu 20.04+ / equivalent",
        "150 MB free storage",
        "GTK 3 runtime installed, Internet connection"
    )
}




@Composable
fun requirementRow(label: String, value: String) {
    Row(
        Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween
    ) {
        P(
            Modifier
                .fontSize(14.px)
                .color(GradeMateColors.TextSecondary)
                .toAttrs()
        ) {
            Text(label)
        }

        P(
            Modifier
                .fontSize(14.px)
                .fontWeight(FontWeight.Medium)
                .color(GradeMateColors.TextPrimary)
                .toAttrs()
        ) {
            Text(value)
        }
    }
}